import moment from "moment";
import React, { useEffect, useState } from "react";
import Confetti from "react-confetti";
import { Redirect } from "react-router";
import PP from "../components/PP";

function PaymentPopup(props) {
	if (props.location.state) {
		var data = props.location.state.data;
		var initialAmount = props.location.state.amount;
		var couponCode = props.location.state.couponCode;

		console.log(data);
	}
	console.log(props);

	// console.log(url.split("?"));

	// var name = data[3].split("%20").join(" ");
	const [mod, setMod] = useState(false);
	// const [data, setData] = useState(window.data);
	// console.log(moment(window.data.date_purchased).format());
	// console.log(newWindow.location.assign);
	const [log, setLog] = useState(false);

	// useEffect(() => {
	//   fetch("https://cantileverlabs.herokuapp.com/getProfile", {
	//     headers: { authorization: "Bearer " + localStorage.getItem("token") },
	//   })
	//     .then((res) => res.json())
	//     .then((data) => {
	//       if (data.user) {
	//         setLog(true);
	//         console.log(data.user);

	//         setUserEmail(data.user.email);
	//       } else {
	//         setLog(false);
	//       }
	//       console.log(userEmail);
	//       console.log(orderEmail);
	//       console.log(orderEmail == userEmail);
	//     });
	// }, []);

	useEffect(() => {
		setMod(true);
	}, []);

	return (
		<div>
			<br />
			<br />
			<br />
			<br />
			{props.location.state ? (
				<PP
					date={data.date_purchased}
					cost={data.amount}
					initialAmount={initialAmount}
					name={data.name}
					email={data.email}
					order_id={data.id}
					couponCode={couponCode}
					show={mod}
					onClose={() => setMod(false)}
				/>
			) : (
				<Redirect to="/" />
			)}

			{/* <Confetti
        height={window.innerHeight - 10}
        width={window.innerWidth - 10}
      /> */}
			{/* {data ? (
        <PP
          date={data.date_purchased}
          cost={data.amount}
          initialAmount={initialAmount}
          name={data.name}
          email={data.email}
          order_id={data.id}
          couponCode={couponCode}
          show={mod}
          onClose={() => setMod(false)}
        />
      ) : (
        <Redirect to="/" />
      )} */}
		</div>
	);
}

export default PaymentPopup;
